module.exports = {
    methods: {
        phoneInput(number, phoneObject) {
            if(number !== undefined && phoneObject !== undefined) {
                this.form.phone =  number ? number : ''
                this.form.dial_code = phoneObject ? phoneObject.country.dialCode : null
                this.form.country_code = phoneObject ? phoneObject.country.iso2 : null
            }
        },

        waPhoneInput(number, phoneObject) {
            if(number !== undefined && phoneObject !== undefined) {
                this.form.wa_phone =  number ? number : ''
                this.form.wa_dial_code = phoneObject ? phoneObject.country.dialCode : null
                this.form.wa_country_code = phoneObject ? phoneObject.country.iso2 : null
            }
        },
    },
}
